export enum PageType {
    CARDS_PAGE = "CARDS_PAGE",
    QUESTION_PAGE = "QUESTION_PAGE",
}
